<template>
  <div class="compose-toolbar mb-4">
    <b-modal
        v-model="findUserModalActive"
        scroll="keep"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
        :destroy-on-hide="false">
        <template #default="props">
          <find-users-modal :active="findUserModalActive" @close="props.close"></find-users-modal>
        </template>
    </b-modal>
    <div class="level">
      <div class="level-left">
        <AutoNumberToolbar />
      </div>
      <div class="level-right">
        <div class="level-item">
          <b-button @click="findUserModalActive = true" icon-left="user">@Users</b-button>
        </div>
        <div class="level-item">
          <div class="buttons has-addons are-normal">
            <b-button
                @click="$store.dispatch('createNewThread')"
                icon-left="plus"
            >New</b-button>
            <b-button
                @click.prevent="deleteThread"
                icon-left="minus"
                type=""
            >Delete</b-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AutoNumberToolbar from "./toolbar/AutoNumberToolbar";
import FindUsersModal from "../modals/FindUsersModal";

export default {
  name: "ComposeToolbar",
  components: {FindUsersModal, AutoNumberToolbar},

  data() {
    return {
      findUserModalActive: false
    }
  },
  computed: {
    activeThread() {
      return this.$store.state.compose.activeThread
    }
  },
  methods: {
    deleteThread() {
      if (this.$store.getters.threadEmpty(this.activeThread)) {
        this.$store.dispatch('removeThread', this.activeThread)
      } else {
        this.$buefy.dialog.confirm({
          message: 'Are you sure you want to delete this thread?',
          scroll: 'keep',
          onConfirm: () => {
            this.$store.dispatch('removeThread', this.activeThread)
            this.$buefy.snackbar.open({
              message: 'Thread deleted',
              position: 'is-top',
              actionText: "OK",
              duration: 3000
            })
          }
        })
      }
    }

  }
}
</script>

